import { dataCookieDefs } from "../state";

const hostname = document.location.hostname;

/**
 * Removes a cookie from the browser.
 * Used for web app integration.
 * @param name - Name of the cookie to remove.
 */
export const clearDomainCookie = (name: string) => {
  //find the first . in the url and return everything after that to seperate the subdomain
  const domainName = hostname.substring(hostname.indexOf('.') + 1);
  //by setting the expiry date to the start of Unix time, the cookie becomes a session cookie and is removed on closing the page
  document.cookie = name + "= ; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=" + domainName + "; path=/; Secure"
}

/**
 * Sets login cookies used by the web app.
 * @param uID - User ID.
 * @param uApiKey - User API Key.
 * @param uApiSecret - User API Secret.
 */
export const setWebAppCookies = (uID: string, uApiKey: string, uApiSecret: string) => {
  setDomainCookie(dataCookieDefs.id, uID);
  setDomainCookie(dataCookieDefs.apiKey, uApiKey);
  setDomainCookie(dataCookieDefs.apiSecret, uApiSecret);
}


/**
 * Checks if web app cookies exist, and if not, refreshes them using passed in user data.
 * @param uID - User ID.
 * @param uApiKey - User API Key.
 * @param uApiSecret - User API Secret.
 */
export const refreshWebAppCookies = (uID: string, uApiKey: string, uApiSecret: string) => {
  const cookies = getLoginCookies();
  if(cookies.length === 0){ 
    setDomainCookie(dataCookieDefs.id, uID);
    setDomainCookie(dataCookieDefs.apiKey, uApiKey);
    setDomainCookie(dataCookieDefs.apiSecret, uApiSecret);
  }
}

/**
 * Set a cookie in the browser for this domain.
 * Used for web app integration.
 * @param name - Name of the cookie to add. 
 * @param data - Data to add to the cookie entry.
 * @param customDate - Optional. Defines a custom time/date that the cookie expires.
 */
const setDomainCookie = (name: string, data: string, customDate?: Date) => {
  //find the first . in the url and return everything after that to seperate the subdomain
  const domainName = hostname.substring(hostname.indexOf('.') + 1);
  //If no custom date is defined, set the cookie timeout to be +1 year from now
  const date = customDate ? customDate : new Date(new Date().setFullYear(new Date().getFullYear() + 1));

  document.cookie = name + "=" + data + "; expires=" + date + "; domain=" + domainName + "; path=/; Secure";
}

//From https://www.w3schools.com/js/js_cookies.asp
const getCookie = (cookieName: string): string | null => {

  let name = cookieName + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let cookieArray = decodedCookie.split(';');

  for (let i = 0; i < cookieArray.length; i++) {
    let curCookie = cookieArray[i];
    //remove spaces
    while (curCookie.charAt(0) === ' ') {
      curCookie = curCookie.substring(1);
    }
    if (curCookie.indexOf(name) === 0) {
      return curCookie.substring(name.length, curCookie.length);
    }
  }
  
  return null;
}
  
/**
 * Returns web app login cookies as a string array.
 */
const getLoginCookies = (): (string | null)[] => {

  const cookies: (string | null)[] = [];

  cookies[0] = getCookie(dataCookieDefs.id)
  cookies[1] = getCookie(dataCookieDefs.apiKey)
  cookies[2] = getCookie(dataCookieDefs.apiSecret)

  for (const cookie of cookies) {
      if (cookie === null)
      {
          //if even one is missing, return null
          return []
      }
  }

  return [...cookies];
}

/**
 * Sets users preference for cookies used on the site.
 * @param showOptionalCookies - If optional cookies should be tracked or not.
 */
export function setCookieConsent(showOptionalCookies: boolean) {  
  setDomainCookie(dataCookieDefs.cookieConsent, String(showOptionalCookies));
}

export function getCookieConsent(): boolean | undefined {
  const ccCookie = getCookie(dataCookieDefs.cookieConsent);

  if(ccCookie) {
    return ccCookie === "true" ? true : false;
  } 
  else {
    return undefined;
  }
}